import React, { useState } from "react";

// Context
import {
  ALERT_ACTIONS,
  ALERT_STATUSES,
  useAlert,
} from "../../../context/AlertProvider";

// API
import requests from "../../../api/api";

// Components
import Modal from "../../Modal/Modal";
import { EmailInput } from "../../Controls/EmailInput";
import { SubmitButton } from "../../Controls/SubmitButton";
import StackStyle from "../../Styled/Stack.style";

// Utils
import colors from "../../../utils/constants/COLORS";
import {
  useSpecialValidation,
  VALIDATIONS,
} from "../../../utils/hooks/useValidation";
import inputValidators from "../../../utils/helpers/inputValidators";
import useToast, { TOAST_TYPES } from "../../../utils/hooks/useToast";

const ForgotPasswordModal = ({ inputValue }) => {
  const [email, setEmail] = useState(inputValue ? inputValue : "");
  const [emailError, validate] = useSpecialValidation(VALIDATIONS.EMAIL, email);

  const [isLoading, setIsLoading] = useState(false);

  const [bannerAlert, setBannerAlert] = useState({
    color: colors.default,
    message: `That's okay, it happens! Enter your email and and we'll send you a link to reset it.`,
  });
  const [addToast] = useToast();

  const handleSubmitTicket = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    const userName = email.split("@")[0];
    const emailExists = await requests.checkEmailExists(email, userName);

    if (emailExists) {
      const ticketResp = await requests.forgotPasswordTicketSubmit(
        email,
        userName
      );

      if (ticketResp && !ticketResp.errorMessage) {
        addToast(TOAST_TYPES.SUCCESS, "Ticket sent successfully");

        let msg = ticketResp.message;
        if (!msg) {
          msg = `Ticket sent successfully, you will receive an email to reset your password.`;
        }

        setBannerAlert({
          color: colors.success,
          message: msg,
        });
      }
    } else {
      addToast(TOAST_TYPES.ERROR, "Incorrect username");
      setBannerAlert({
        color: colors.critical,
        message: `Something went wrong. Please check if the email you entered is correct.`,
      });
    }

    setIsLoading(false);
  };

  return (
    <Modal title="Forgot your password?">
      <p>{bannerAlert.message}</p>
      <br />
      <EmailInput
        value={email}
        setValue={setEmail}
        isLoading={isLoading}
        error={emailError}
        validate={validate}
        id="email-address-forgot-password"
      />
      <br />
      <StackStyle>
        <SubmitButton
          onClick={handleSubmitTicket}
          disabled={inputValidators.email(email)}
        />
      </StackStyle>
    </Modal>
  );
};

export default ForgotPasswordModal;
